var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3457 6.37805C10.6702 6.67316 10.8525 7.07319 10.8525 7.49027C10.8525 7.90736 10.6702 8.30739 10.3457 8.60249L3.81099 14.5392C3.48587 14.8344 3.04499 15.0001 2.58532 15C2.12565 14.9999 1.68485 14.834 1.35989 14.5387C1.03493 14.2435 0.852431 13.8431 0.852539 13.4256C0.852647 13.0081 1.03535 12.6078 1.36047 12.3127L6.6705 7.49027L1.36047 2.66785C1.04462 2.37114 0.869732 1.97364 0.873465 1.56097C0.877198 1.1483 1.05925 0.753461 1.38042 0.461509C1.70159 0.169557 2.13618 0.00384534 2.59058 6.60825e-05C3.04497 -0.00371318 3.48283 0.154742 3.80983 0.441304L10.3457 6.37805Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoArrowLeft);
export default __webpack_public_path__ + "static/media/mo_arrow_left.351115d221145eb55dbb82c07b2d738c.svg";
export { ForwardRef as ReactComponent };